import { render, staticRenderFns } from "./ehs.vue?vue&type=template&id=529e938c&scoped=true&v-once=true"
import script from "./ehs.vue?vue&type=script&lang=js"
export * from "./ehs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e938c",
  null
  
)

export default component.exports